import React, {Component} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import isCssAnimationSupported from "./isCssAnimationSupported";

import style from "./Spin.less";


class Spin extends Component {

    static defaultProps = {
        prefixCls: "lianfan-spin",
        spinning: true,
        size: "default",
    };

    static propTypes = {
        prefixCls: PropTypes.string,
        className: PropTypes.string,
        spinning: PropTypes.bool,
        size: PropTypes.oneOf(["small", "default", "large"]),
    };


    constructor(props) {
        super(props);
        const spinning = props.spinning;
        this.state = {
            spinning,
        };
    }

    isNestedPattern() {
        return !!(this.props && this.props.children);
    }

    componentDidMount() {
        if (!isCssAnimationSupported()) {
            // Show text in IE9
            this.setState({
                notCssAnimationSupported: true,
            });
        }
    }

    componentWillUnmount() {
        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        if (this.delayTimeout) {
            clearTimeout(this.delayTimeout);
        }
    }


    componentWillReceiveProps(nextProps) {
        const currentSpinning = this.props.spinning;
        const spinning = nextProps.spinning;
        const {delay} = this.props;

        if (this.debounceTimeout) {
            clearTimeout(this.debounceTimeout);
        }
        if (currentSpinning && !spinning) {
            this.debounceTimeout = window.setTimeout(() => this.setState({spinning}), 200);
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
            }
        } else {
            if (spinning && delay && !isNaN(Number(delay))) {
                if (this.delayTimeout) {
                    clearTimeout(this.delayTimeout);
                }
                this.delayTimeout = window.setTimeout(() => this.setState({spinning}), delay);
            } else {
                this.setState({spinning});
            }
        }
    }

    renderIndicator() {
        const {prefixCls, indicator} = this.props;
        const dotClassName = `${prefixCls}-dot`;
        if (React.isValidElement(indicator)) {
            return React.cloneElement(indicator, {
                className: classNames(indicator.props.className, dotClassName),
            });
        } else {
            return (
                <span className={classNames(dotClassName, `${prefixCls}-dot-spin`)}>
                    <i className={`${dotClassName}-item`} />
                    <i className={`${dotClassName}-item`} />
                    <i className={`${dotClassName}-item`} />
                    <i className={`${dotClassName}-item`} />
                </span>);
        }

    }


    render() {
        const {className, size, prefixCls, tip, wrapperClassName, ...restProps} = this.props;
        const {spinning, notCssAnimationSupported} = this.state;

        const spinClassName = classNames(prefixCls, {
            [`${prefixCls}-sm`]: size === "small",
            [`${prefixCls}-lg`]: size === "large",
            [`${prefixCls}-spinning`]: spinning,
            [`${prefixCls}-show-text`]: !!tip || notCssAnimationSupported,
        }, className);

        // fix https://fb.me/react-unknown-prop
        const divProps = _.omit(restProps, [
            "spinning",
            "delay",
            "indicator",
        ]);

        // 改变1.
        // <div {...divProps} className={spinClassName}> ===> <div  className={spinClassName}>
        const spinElement = (
            <div className={spinClassName}>
                {this.renderIndicator()}
                {tip
                    ? <div className={`${prefixCls}-text`}>{tip}</div>
                    : null}
            </div>
        );


        if (this.isNestedPattern()) {
            let animateClassName = prefixCls + "-nested-loading";
            if (wrapperClassName) {
                animateClassName += " " + wrapperClassName;
            }
            const containerClassName = classNames({
                [`${prefixCls}-container`]: true,
                [`${prefixCls}-blur`]: spinning,
            });
            return (
                // 改变2. 否则 fade 效果下spin背景将和后面内容叠加
                // <Animate
                //     {...divProps}
                //     component="div"
                //     className={animateClassName}
                //     style={null}
                //     transitionName="fade">
                //     {
                //         spinning && <div key="loading">{spinElement}</div>
                //     }
                //     <div className={containerClassName} key="container">
                //         {this.props.children}
                //     </div>
                // </Animate>
                <div{...divProps}
                    className={animateClassName}
                    style={null}>
                    {
                        spinning && <div key="loading">{spinElement}</div>
                    }
                    <div className={containerClassName} key="container">
                        {this.props.children}
                    </div>
                </div>
            );
        }
        return spinElement;
    }
}


export default Spin;
